import React from 'react';
import PropTypes from 'prop-types';
import WaterRegionalNavigation from './WaterRegional';

const Navigation = (props) => {
  const {
    document,
    openCollapse,
    closeCollapse,
    changeHeight,
    activeDrawer,
    drawerIsOpen,
    section,
  } = props;

  return (
    <WaterRegionalNavigation
      entryTitle={document?.fields?.entryTitle || ''}
      fields={document?.fields?.navigation}
      openCollapse={openCollapse}
      closeCollapse={closeCollapse}
      changeHeight={changeHeight}
      activeDrawer={activeDrawer}
      drawerIsOpen={drawerIsOpen}
      section={section}
    />
  );
};

Navigation.propTypes = {
  document: PropTypes.object,
  openCollapse: PropTypes.func.isRequired,
  closeCollapse: PropTypes.func.isRequired,
  changeHeight: PropTypes.func,
  activeDrawer: PropTypes.string,
  drawerIsOpen: PropTypes.bool.isRequired,
  section: PropTypes.string,
};

export default Navigation;
